module.exports = __webpack_public_path__ + "images/no-avatar-60x60.8ff704d7.svg";